import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-form-field-icon',
  templateUrl: './form-field-icon.component.html',
  styleUrls: ['./form-field-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldIconComponent {}
